export default __webpack_public_path__ + "static/media/Icon_i.299fa11f.svg";